import { ContractBuilderBaseLoading } from './ContractBuilderBaseLoading';

export const ContractBuilderFormViewLoading = () => {
  return (
    <ContractBuilderBaseLoading>
      <div className="mx-10 mt-12 flex min-h-screen grow items-start pb-24">
        <div className="h-full w-full max-w-3xl animate-pulse p-6">
          <div className="bg-info-200 -mt-2 mb-4 h-[24px] w-[220px] rounded-full pb-4" />
          <div className="mt-8 mb-5 h-[256px] rounded-lg bg-white p-6 pb-2 shadow-sm" />
          <div className="mb-5 h-[78px] rounded-lg bg-white p-6 pb-2 shadow-sm" />
          <div className="mb-5 h-[78px] rounded-lg bg-white p-6 pb-2 shadow-sm" />
          <div className="mb-5 h-[320px] rounded-lg bg-white p-6 pb-2 shadow-sm" />
          <div className="mb-5 h-[256px] rounded-lg bg-white p-6 pb-2 shadow-sm" />
        </div>
        <div className="mt-12 ml-6 flex min-w-[472px] flex-col gap-y-4 rounded-sm bg-white px-8 py-4 shadow-sm">
          <div className="mt-4 flex items-center gap-x-2">
            <div className="bg-info-200 h-5 w-5 rounded-full" />
            <div className="bg-info-200 h-4 w-1/2 rounded-md" />
            <div className="bg-info-200 ml-auto h-[20px] w-[84px] rounded-full"></div>
          </div>
          <div className="flex items-center gap-x-2">
            <div className="bg-info-200 h-5 w-5 rounded-full" />
            <div className="bg-info-200 h-4 w-1/2 rounded-md" />
            <div className="bg-info-200 ml-auto h-[20px] w-[84px] rounded-full"></div>
          </div>
          <div className="flex items-center gap-x-2">
            <div className="bg-info-200 h-5 w-5 rounded-full" />
            <div className="bg-info-200 h-4 w-1/2 rounded-md" />
            <div className="bg-info-200 ml-auto h-[20px] w-[84px] rounded-full"></div>
          </div>
          <div className="flex items-center gap-x-2">
            <div className="bg-info-200 h-5 w-5 rounded-full" />
            <div className="bg-info-200 h-4 w-1/2 rounded-md" />
            <div className="bg-info-200 ml-auto h-[20px] w-[84px] rounded-full"></div>
          </div>
          <div className="flex items-center gap-x-2">
            <div className="bg-info-200 h-5 w-5 rounded-full" />
            <div className="bg-info-200 h-4 w-1/2 rounded-md" />
            <div className="bg-info-200 ml-auto h-[20px] w-[84px] rounded-full"></div>
          </div>
          <div className="flex items-center gap-x-2">
            <div className="bg-info-200 h-5 w-5 rounded-full" />
            <div className="bg-info-200 h-4 w-3/4 rounded-md" />
            <div className="bg-info-200 ml-auto h-[20px] w-[84px] rounded-full"></div>
          </div>
          <div className="border-info-300 mr-4 flex justify-between border-t pt-6 pb-4">
            <div className="bg-info-200 h-[40px] w-[126px] rounded-md"></div>
          </div>
        </div>
      </div>
    </ContractBuilderBaseLoading>
  );
};
